import { render, staticRenderFns } from "./CreatorGalleryShareFollowers.vue?vue&type=template&id=588ba7e4&"
import script from "./CreatorGalleryShareFollowers.vue?vue&type=script&lang=js&"
export * from "./CreatorGalleryShareFollowers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports